var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCollect = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 80,
  height: 80,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58.25 17.609h-4.638A15.738 15.738 0 0 0 40.763 11c-6.933 0-12.818 4.454-14.908 10.635h-5.134C12.04 21.635 5 28.619 5 37.235c0 8.614 7.039 15.599 15.721 15.599H58.25c9.803 0 17.75-7.886 17.75-17.613S68.053 17.61 58.25 17.61Z",
  className: "collect_svg__primary"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m51.272 55.028-7.428 6.564V41.28c1.622-.938 2.716-2.679 2.716-4.677 0-2.99-2.443-5.414-5.456-5.414-3.013 0-5.456 2.424-5.456 5.414 0 1.998 1.094 3.739 2.717 4.677v20.313l-7.429-6.564-2.198 3.786L41.104 70 53.47 58.814l-2.198-3.786Z",
  className: "collect_svg__secondary"
})));
export default SvgCollect;